// FileUpload.js
import React, { useState, useRef } from 'react';
import { Box, Typography, Paper, Stack, LinearProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

// Adicione a prop onFileProcessed
const FileUpload = ({ label, onFileProcessed }) => {
 const [file, setFile] = useState(null);
 const [isLoading, setIsLoading] = useState(false);
 const [error, setError] = useState('');
 const fileInputRef = useRef(null);

  // Torna a função de manipulação de arquivo assíncrona
  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
    setFile(selectedFile);
    setError('');
    setIsLoading(true);
   
   try {
    // Espera a função onFileProcessed ser concluída
    await onFileProcessed(selectedFile);
    setError('sucesso: Arquivo processado com sucesso!');
    } catch (err) {
    // Captura o erro da função onFileProcessed, se houver
    setError(`Erro ao processar o arquivo: ${err.message || 'Erro desconhecido'}`);
    } finally {
    // Isso sempre será executado, independentemente de sucesso ou erro
    setIsLoading(false);
    }
    }
  };

 const handlePaperClick = () => {
  if (!isLoading) {
   fileInputRef.current.click();
  }
 };

  // Torna a função de drag and drop assíncrona
  const handleDrop = async (event) => {
    event.preventDefault();
    if (!isLoading) {
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
    setFile(droppedFile);
    setError('');
    setIsLoading(true);
   
    try {
    // Espera a função onFileProcessed ser concluída
    await onFileProcessed(droppedFile);
    setError('sucesso: Arquivo processado com sucesso!');
    } catch (err) {
    // Captura o erro da função onFileProcessed, se houver
    setError(`Erro ao processar o arquivo: ${err.message || 'Erro desconhecido'}`);
    } finally {
    setIsLoading(false);
    }
    }
    }
    };

 const handleDragOver = (event) => {
  event.preventDefault();
 };

 return (
  <Box sx={{ p: 3, maxWidth: '800px', mx: 'auto' }}>
   <Typography variant="body1" sx={{ mb: 2 }}>
    Caminho no swfast: {label}
   </Typography>

   <Typography variant="body1" sx={{ mb: 1 }}>
    Selecione o arquivo e arraste:
   </Typography>

   <Paper
    variant="outlined"
    sx={{
     p: 2,
     textAlign: 'center',
     cursor: isLoading ? 'default' : 'pointer',
     border: '2px dashed',
     borderColor: error.includes('sucesso') ? 'success.main' : (error ? 'error.main' : (file ? 'success.main' : 'text.secondary')),
     '&:hover': {
      borderColor: isLoading ? 'text.secondary' : 'primary.main',
      backgroundColor: isLoading ? 'background.paper' : 'action.hover',
     },
     backgroundColor: 'background.paper',
     position: 'relative',
     transition: 'all 0.2s ease-in-out',
     height: '80px'
    }}
    onClick={handlePaperClick}
    onDrop={handleDrop}
    onDragOver={handleDragOver}
   >
    <input
     type="file"
     hidden
     ref={fileInputRef}
     onChange={handleFileChange}
     accept=".xlsx, .xls, .csv"
    />
    <Stack
     direction="column"
     alignItems="center"
     spacing={0}
    >
     <CloudUploadIcon
      sx={{
       fontSize: 40,
       color: 'text.secondary',
       transition: 'color 0.2s ease-in-out',
      }}
     />
     <Typography variant="body1" sx={{ color: 'text.secondary' }}>
      {file ? file.name : 'Clique aqui ou arraste e solte o arquivo'}
     </Typography>
     <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      Limite de 200MB por arquivo .XLSX, .XLS, .CSV
     </Typography>
    </Stack>
   </Paper>

   {isLoading && (
     <Box sx={{ width: '100%', mt: 2 }}>
      <LinearProgress />
      <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
       Processando arquivo...
      </Typography>
     </Box>
    )}

   {error && (
    <Typography
     variant="body2"
     color={error.includes('sucesso') ? 'success.main' : 'error.main'}
     sx={{ mt: 2, textAlign: 'center' }}
    >
     {error}
    </Typography>
   )}
  </Box>
 );
};

export default FileUpload;